export const getLinkableVariables = availableVariables => {
  return availableVariables?.filter(t => t.type === 'link')
}

export const getSectionsWithLinkableVariables = (availableVariables, availableSections) => {
  return availableSections?.filter(section =>
    availableVariables.some(variable => variable.section === section.id && variable.type === 'link')
  )
}
